import React from "react";
import { Form, Button } from "tabler-react";

const CheckboxOption = ({ onChange, conditions, condition, onClear }) => (
  <Form.Checkbox
    checked={(conditions || []).includes(condition)}
    label={condition}
    name="condition"
    value={condition}
    onChange={onChange}
  />
);

const CONDITION_OPTIONS = [
  "Appears New",
  "As Is",
  "Brand New",
  "Good Condition",
  "Open Box",
  "Other",
  "Preview For Condition",
  'Working Condition Verified',
];

const ConditionOptions = ({
  onClear,
  handleSelectCondition,
  conditions: currentConditions,
  conditionOptions = CONDITION_OPTIONS,
}) => (
  <Form.Group label="Conditions">
    {conditionOptions.map((condition) => (
      <CheckboxOption
        key={condition}
        condition={condition}
        onChange={handleSelectCondition}
        conditions={currentConditions}
      />
    ))}
    <Button onClick={onClear} color="secondary">
      Clear
    </Button>
  </Form.Group>
);

export default ConditionOptions;



// WEBPACK FOOTER //
// ./src/components/ConditionsSelect.js